import PLATFORM_TYPES_ENUM from "../../../lib/enums/platformTypes";
import { createFieldPresets } from "../fieldPresets";
import * as Yup from "yup";

export const createUserSchema = (t) => {
  const f = createFieldPresets(t);

  const clientPropertyCondition = {
    is: (v) => v !== PLATFORM_TYPES_ENUM.CLIENT,
    then: (schema) => schema.notRequired().min(0),
  };

  const userShape = {
    id: Yup.string().optional(),
    first_name: f.textShort,
    last_name: f.textShort,
    email: f.email,
    phone_no: f.phone,
    vat_number: f.textShort.when("platform_type", clientPropertyCondition),
    company_name: f.textShort.when("platform_type", clientPropertyCondition),
    address: f.textShort.when("platform_type", clientPropertyCondition),
    city: f.textShort.when("platform_type", clientPropertyCondition),
    postal_code: f.textShort.when("platform_type", clientPropertyCondition),
    country: f.textShort.when("platform_type", clientPropertyCondition),
    role_id: Yup.number().required(t("validation.chooseOption")),
    parent_user_id: Yup.string(),
    platform_type: Yup.string(),
  };

  return Yup.object(userShape);
};
